import { gql } from 'src/__generated__';

export const GET_PRIORITY_APPLY_CREDIT = gql(`
  query GetPriorityApplyCredit(
    $locale: Locale!,
    $timezone: Timezone!,
    $zone: Zone!,
    $languageCode: LanguageCodeIso!,
    $showStrongInterestEndState: Boolean!
  ) {
    priorityApplyCredit {
      ... PriorityApplyCreditFragment
      creditConfig {
        creditValue
        renewFrequency {
          value
          unit
        }
      }
    }
  }

  fragment PriorityApplyCreditFragment on PriorityApplyCredit {
    credit2(zone: $zone, languageCode: $languageCode) @include(if: $showStrongInterestEndState) {
      ... on PrioritizedCredit {
        remainingCount
        totalCredit
        nextRenewalDate {
          shortAbsoluteLabel(timezone: $timezone, locale: $locale)
        }
      }
      ... on PendingCredit {
        remainingCount
        totalCredit
        nextRenewalDate {
          shortAbsoluteLabel(timezone: $timezone, locale: $locale)
        }
      }
    }
  }
`);
